import styled, { css } from 'styled-components';

const styles = css`
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  font-size: var(--font-size-sm);

  ${({ responsive }) =>
    responsive
      ? css`
          @media (min-width: 992px) {
            display: table-cell;
            padding: 16px 8px;

            &:first-child {
              padding-left: 15px;
            }
            &:last-child {
              /* padding-right: 15px; */
            }
          }
          @media (min-width: 1200px) {
            padding: 10px 8px;
          }
          @media (min-width: 1450px) {
            padding: 22px 8px;
          }
        `
      : css`
          display: table-cell;
          padding: 16px 8px;

          /* &:first-child {
            padding-left: 15px;
          }
          &:last-child {
            padding-right: 15px;
          } */

          @media (min-width: 1200px) {
            padding: 10px 8px;
          }
          @media (min-width: 1000px) {
            padding: 22px 8px;
          }
        `}

        .profile-skeleton{
          display: flex;
          align-items: center;
          gap: 20px;
        }
`;

export const Th = styled.th`
  ${styles}
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
  /* text-transform: capitalize; */
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: ${({ $align }) => ($align ? 'center' : 'left')};
  background: rgba(253, 253, 253, 0.2);
  
  &:first-child {
    text-align: left;
  }
  &:last-child {
    /* text-align: right; */
  }

`;

export const Td = styled.td`
  font-weight: 400;

  ${styles}
  text-align: ${({ $align }) => ($align ? 'center' : 'left')};

  &:first-child {
    width: 300px;
    word-break: break-all;
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;

    @media (min-width: 1450px) {
      font-size: 14px;
      line-height: 18px;
    }
    
    span {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;

      @media (min-width: 1450px) {
        font-size: 14px;
        line-height: 18px;

      }
    }

    label {
      width: auto;
    }
  }
  &:last-child {
    /* text-align: right; */
  }
  ${({ responsive }) =>
    responsive &&
    css`
      display: flex;
      justify-content: space-between;
      @media (max-width: 991px) {
        padding: 10px 5px;
        border-bottom: 1px solid rgba(241, 241, 241, 1);
        /* &:last-child {
          height: 0;
          padding: 0;
        } */
        /* &:nth-child(odd) {
          background: var(--gray-3);
          border-radius: 8px;
        } */
      }
      &:before {
        content: attr(data-th);
        font-weight: bold;
        display: inline-block;
        color: rgba(49, 49, 49, 1);
        font-weight: 600;
        padding-right: 12px;
        @media (min-width: 992px) {
          display: none;
        }
      }
    `}
`;
